import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
interface IActions {
  url: string;
  title: string;
}
interface IToasterObject {
  Message: string;
  Title: string;
  Type?: 'success' | 'error' | 'info' | 'warning';
  // TimeOut: number;
  actions?: IActions[];
}
@Injectable({
  providedIn: 'root',
})
export class CustomToasterService {
  constructor(private toastrService: ToastrService, private router: Router) {}

  navigateToUrl(url: string) {
    this.router.navigate([url]);
  }
  showMessage(ToasterObject?: IToasterObject) {
    // Default values if properties are missing
    const message = ToasterObject?.Message;
    const title = ToasterObject?.Title;
    const type = ToasterObject?.Type || 'success';
    // const timeOut = ToasterObject?.TimeOut || 3000;
    const actions = ToasterObject?.actions || [];

    let actionButtons = '';
    actions.forEach((action) => {
      actionButtons += `<a class="btn__redirect my__home" data-url="${action.url}">${action.title}</a>`;
    });
    // actionButtons += `<a href="${action.url}" class="btn__redirect my__home">${action.title}</a>`;

    // let actionButtons = '';
    // actions.forEach((action) => {
    //   actionButtons += `<a class="btn__redirect my__home" onclick="window.location.href='${action.url}'">${action.title}</a>`;
    // });
    const imgTypes = {
      success: 'assets/images/services/Icon-check.svg',
      error: 'assets/images/services/error-Icon.svg',
      info: 'assets/images/services/info-Icon.svg',
      warning: 'assets/images/services/warning-Icon.svg',
    };
    const successMessage = `

        <div class="custom__toaster__inner ${type}">
        <div class="custom__toaster__icon ${type}">
          <img src="${imgTypes[type]}" alt="${type}-icon">
        </div>
        <div class="custom__toaster__content">
          <div class="custom__toaster__text">
            <div class="custom__toaster__title">${title}</div>
            <div class="custom__toaster__description">${message}</div>
          </div>
        </div>
        </div>

    `;
    this.toastrService.success(successMessage, '', {
      enableHtml: true,
      toastClass: 'custom__toaster',
      timeOut: 5000,
      tapToDismiss: false,
      positionClass: 'toast-top-center',
      closeButton: true,
    });

    setTimeout(() => {
      document.querySelectorAll('.btn__redirect').forEach((button) => {
        button.addEventListener('click', (e: Event) => {
          e.preventDefault(); // Prevent the default anchor behavior
          const url = (e.target as HTMLAnchorElement).getAttribute('data-url');

          if (url) {
            this.navigateToUrl(url);
            // this.router.navigate([url]);
          }
        });
      });
    }, 0);
  }
  showFailedMessage() {
    const failedMessage = 'failed!';
    this.toastrService.success(failedMessage, '', {
      enableHtml: true,
    });
  }
}

// const successMessage = `

// <div class="custom__toaster__icon">
//   <img src="${imgTypes[type]}" alt="${type}-icon">
// </div>
// <div class="custom__toaster__content">
//   <div class="custom__toaster__text">
//     <div class="custom__toaster__title">${title}</div>
//     <div class="custom__toaster__description">${message}</div>
//   </div>
//   <div class="custom__toaster__content__action">
// ${actionButtons}
//   </div>
// </div>

// `;
